import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

////////// estilos ///////////////
const useStyles = makeStyles((theme) => ({
    formControl: {
      width: "100%",
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));



export default function SelectorGrupos(props) {
  ////////// estilos ///////////////
  const classes = useStyles();
  ///////////////// variables ////////////////
  
  const [state, setState] = useState('');
  const [grupos, setGrupos] = useState([]);

  const handleChange = async(event) => {
    const a = event.target.value
    setState(a)
    props.func(a);
    props.subG(a)
  };
  
    
  ////////////////////////////////////  ///////

  ////////// funciones ///////////////
  useEffect(() => {    
    setGrupos(props.grupos)    
    // eslint-disable-next-line
  }, [props]);

  return (
    <div>
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel id="grupoDisposi">Dispositivos</InputLabel>
        <Select
          labelId="grupoDisposi"
          id="grupoDisposi"
          value={state.nombre}
          onChange={handleChange}
          label="grupoDisposi"
        >
        {grupos.length === 0 ? 
                <MenuItem value="">
                    <em>No posee dispositivos registrados</em>
                </MenuItem>
            :grupos.map((g) =>(
                <MenuItem value={g}>{g.nombre}</MenuItem>
            ))

        }         
        </Select>
      </FormControl> 
    </div>
  );
};


